export default "__VITE_ASSET__DHOF3lxV__"